module.exports = __webpack_public_path__ + "img/index_tejrb.237838b0.png";